module.exports = __webpack_public_path__ + "static/media/logoLightClose.3c85da5d.svg";